import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sonar-extractor-datastudio',
  templateUrl: './sonar-extractor-datastudio.component.html',
  styleUrls: ['./sonar-extractor-datastudio.component.css'],
})
export class SonarExtractorDatastudioComponent {
  datastudioUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.datastudioUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.DATASTUDIO_URL
    );
  }
}
